import React from 'react';
import { useEffect } from 'react';

// @shared/components
import VerticalTab from '../../../shared/components/Tabs/VerticalTab';

// components
import Bundles from './Bundles/Bundles';
import MicroCredentials from './MicroCredentials/MicroCredentials';
import Insignias from './Badge/Badge';
import Reglas from './Rules/Rules';



import { eventData, eventTracker } from '../../../shared/components/EventTracker/EventTracker';

const Catalogos = (props) => {
    const [activeTabIndex, setActiveTabIndex] = React.useState(0);
    const [activeCatalogsInfoTab, setActiveCatalogsInfoTab] = React.useState(0);
    const TABINDEX = 2;
    const labels = [
        {  title: 'Bundles' },
        {  title: 'Microcredenciales' },
        {  title: 'Insignias' },
        {  title: 'Asignación Reglas' },
    ];

    useEffect(() => {
        eventTracker('s_catalogos', eventData, ['mixpanel']);
    }, []);

    const isCurrentTab = (val) => {
        return activeTabIndex === TABINDEX && activeCatalogsInfoTab === val ? true : false;
    };


    const panels = [<Bundles isCurrentTab={isCurrentTab(0)} />, 
    <MicroCredentials isCurrentTab={isCurrentTab(1)} />,
    <Insignias isCurrentTab={isCurrentTab(2)} />,
    <Reglas isCurrentTab={isCurrentTab(3)} />];

    useEffect(() => {
        setActiveTabIndex(props.activeTabIndex);
    }, [props.activeTabIndex]);

    return (
        <VerticalTab labels={labels} panels={panels} setActiveCatalogsInfoTab={setActiveCatalogsInfoTab} />
    )
};

export default Catalogos;